/*----------------------------------
- HOME: CLOSING CARD
----------------------------------*/

/**
 * The closing card before the FAQ (`section#dashboard`), Home v3 (2026-11-04): "Ready to see your first matches?" on the
 * sunset outposts picture, "Start with my search", and the investor's and the founder's dashboards in one window under
 * a drag slider. The persona switch left the card (the mock's rule), so the card reads no persona: the demo window
 * keeps the page's one persona. It grows from the cards' width to the hero card's as it scrolls in.
 *
 * @docs docs/features/website-landing-experience
 * @adr  ADR-0110
 * @rule The call to action fires the catalogued final id `website_landing_final_try_free` with the shipped final
 *       attribution; the card carries `landing-home-footer-product-entry-card`, moved here from the old dark card.
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import { DATABASE_SEARCH_ACTIONS } from '@uniquedomains/components/contracts/search/searchAccessCatalog';
import { ClosingCard } from '@uniquedomains/components/marketing/closing-card/ClosingCard';

import { HOME_CLOSING_COPY } from '@/client/catalogs/landing/home/homeCopy';
import { trackConversionTrigger } from '@/client/pages/landing/lib/trackConversionTrigger';
import { trackLandingCta } from '@/client/pages/landing/lib/trackLandingCta';
import { buildWebsiteAuthHref } from '@/client/utils/conversion/authHref';
import { HOME_DASHBOARD_SCREENS } from './demoScreens';
import { HOME_CLOSING_SCENE } from './homeScenes';

/*----------------------------------
- CONSTANTS
----------------------------------*/

/** No persona on this link: the modal's persona screen asks, since the slider above it only previews the dashboards. */
const CLOSING_SIGNUP_HREF = buildWebsiteAuthHref({
    flow: 'cold',
    mode: 'signup',
    feature: 'databaseAccess',
    action: DATABASE_SEARCH_ACTIONS.unlockDatabase,
    from: 'website_landing_final_cta',
});

/*----------------------------------
- HELPERS
----------------------------------*/

const trackClosingCta = () => {
    trackLandingCta({
        page: 'landing_home',
        section: 'final_cta',
        label: HOME_CLOSING_COPY.cta,
        kind: 'product',
        href: CLOSING_SIGNUP_HREF,
        feature: 'databaseAccess',
        action: DATABASE_SEARCH_ACTIONS.unlockDatabase,
    });
    trackConversionTrigger('website_landing_final_try_free', {
        action: DATABASE_SEARCH_ACTIONS.unlockDatabase,
        feature: 'databaseAccess',
        href: CLOSING_SIGNUP_HREF,
        page: CLOSING_SIGNUP_HREF,
        section: 'final_cta',
    });
};

/*----------------------------------
- COMPONENT
----------------------------------*/

const HomeClosingCard = () => (
    <ClosingCard
        id="dashboard"
        heading={HOME_CLOSING_COPY.heading}
        sub={HOME_CLOSING_COPY.sub}
        cta={{ label: HOME_CLOSING_COPY.cta, href: CLOSING_SIGNUP_HREF, testId: 'landing-home-closing-cta', onClick: trackClosingCta }}
        screens={HOME_DASHBOARD_SCREENS}
        compare={HOME_CLOSING_COPY.compare}
        scene={HOME_CLOSING_SCENE}
        cardTestId="landing-home-footer-product-entry-card"
    />
);

export default HomeClosingCard;
